export default "__VITE_ASSET__7bc54adf__"